import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaymentConfirmationComponent } from '../make-a-payment/payment-confirmation/payment-confirmation.component';
import { PaymentDetailsComponent } from '../make-a-payment/payment-details/payment-details.component';
import { PaymentHeaderComponent } from '../make-a-payment/payment-header/payment-header.component';
import { PaymentReviewComponent } from '../make-a-payment/payment-review/payment-review.component';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { NeedAssistanceModule } from '../shared/modules/need-assistance/need-assistance.module';
import { NeedToGoBackModule } from '../shared/modules/need-to-go-back/need-to-go-back.module';
import { CreditInvoiceComponent } from './credit-invoice/credit-invoice.component';
import { CreditsRefundConfirmComponent } from './credits-refund-confirm/credits-refund-confirm.component';
import { CreditsRefundReviewComponent } from './credits-refund-review/credits-refund-review.component';
import { CreditsRefundComponent } from './credits-refund/credits-refund.component';
import { PaymentPaginationComponent } from './pagination/payment-pagination.component';
import { PayAtTermsConfirmationComponent } from './pay-at-terms-confirmation/pay-at-terms-confirmation.component';
import { PayAtTermsDetailsComponent } from './pay-at-terms-details/pay-at-terms-details.component';
import { PayAtTermsReviewComponent } from './pay-at-terms-review/pay-at-terms-review.component';
import { PaymentIntermediateComponent } from './payment-intermediate/payment-intermediate.component';

@NgModule({
  declarations: [
    CreditInvoiceComponent,
    PaymentDetailsComponent,
    PaymentHeaderComponent,
    PaymentReviewComponent,
    PaymentConfirmationComponent,
    PaymentIntermediateComponent,
    CreditsRefundComponent,
    CreditsRefundReviewComponent,
    CreditsRefundConfirmComponent,
    PayAtTermsDetailsComponent,
    PayAtTermsReviewComponent,
    PayAtTermsConfirmationComponent,
    PaymentPaginationComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    NgSelectModule,
    FormsModule,
    NgbModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    NeedToGoBackModule,
    ReactiveFormsModule,
    FluDashboardBannerModule,
    RouterModule,
    NeedAssistanceModule,
    MatProgressSpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountInvoiceComponent: {
          component: () =>
            import('./credit-invoice/credit-invoice.component').then(
              (m) => m.CreditInvoiceComponent
            ),
        },
        AccountOpenInvoicePaymentComponent: {
          component: () =>
            import(
              '../make-a-payment/payment-details/payment-details.component'
            ).then((m) => m.PaymentDetailsComponent),
        },
        OpenInvoicePaymentReviewComponent: {
          component: () =>
            import(
              '../make-a-payment/payment-review/payment-review.component'
            ).then((m) => m.PaymentReviewComponent),
        },
        OpenInvoicePaymentConfirmationComponent: {
          component: () =>
            import(
              '../make-a-payment/payment-confirmation/payment-confirmation.component'
            ).then((m) => m.PaymentConfirmationComponent),
        },
        InvoiceCreditSelectionComponent: {
          component: () =>
            import(
              './payment-intermediate/payment-intermediate.component'
            ).then((m) => m.PaymentIntermediateComponent),
        },
        AccountInvoicePaymentComponent: {
          component: () =>
            import('./credits-refund/credits-refund.component').then(
              (m) => m.CreditsRefundComponent
            ),
        },
        AccountInvoicePaymentReviewComponent: {
          component: () =>
            import(
              './credits-refund-review/credits-refund-review.component'
            ).then((m) => m.CreditsRefundReviewComponent),
        },
        OpenCreditConfirmationComponent: {
          component: () =>
            import(
              './credits-refund-confirm/credits-refund-confirm.component'
            ).then((m) => m.CreditsRefundConfirmComponent),
        },
        AccountFuturePayPaymentComponent: {
          component: () =>
            import(
              './pay-at-terms-details/pay-at-terms-details.component'
            ).then((m) => m.PayAtTermsDetailsComponent),
        },
        AccountFuturePayPaymentReviewComponent: {
          component: () =>
            import('./pay-at-terms-review/pay-at-terms-review.component').then(
              (m) => m.PayAtTermsReviewComponent
            ),
        },
        AccountFuturePayPaymentConfirmationComponent: {
          component: () =>
            import(
              './pay-at-terms-confirmation/pay-at-terms-confirmation.component'
            ).then((m) => m.PayAtTermsConfirmationComponent),
        },
      },
    } as CmsConfig),
  ],
})
export class MakeAPaymentModule {}
